// test2846
(2846 && 0);
